module.exports = __webpack_public_path__ + "static/media/normal.bd2b3fa9.svg";